<template>
  <div class="navigation" @click="onClick">
    <VLangSelect />
    <ul class="margin navigation-list">
      <slot :links="links"></slot>
    </ul>
  </div>
</template>

<script>
import VLangSelect from '@/components/langSelect/VLangSelect'
import { mapState } from 'vuex'

export default {
  name: 'Navigation',
  components: {
    VLangSelect,
  },
  computed: {
    ...mapState('navigation', ['links']),
    currentLang() {
      return this.$store.state.main.currentLang
    },
    dic() {
      return this.$store.state.main.dic
    },
  },

  methods: {
    onClick: function(event) {
      let link = event.target.getAttribute('data-nav')
      this.$root.$emit('navclick', {
        id: link || '',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.margin {
  margin: 10px 0;
}
.navigation {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 41px 20px 40px;
}

.navigation-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: space-between;
  width: 100%;

  max-width: 600px;
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .navigation {
    display: none;
  }
}

@media (max-width: 375px) {
}

@media (max-width: 411px) {
}
</style>
